import { Paths } from "src/constants/paths";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";
import { useIsAdmin } from "./useIsAdmin";

export const useGetQueueRoute = () => {
  const admin = useIsAdmin();
  const provider = useClinician((clinician) =>
    clinician.roles.some((role) => role.name.includes("Provider")),
  );

  const route = admin
    ? Paths.DASHBOARD
    : provider
      ? Paths.PROVIDER_TASK_QUEUE
      : Paths.COORDINATOR_TASK_QUEUE;

  return route;
};
